import * as React from "react";

const SvgIcnEmailBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M20 7.441l-7.776 3.888a.5.5 0 01-.448 0L4 7.441V7a1 1 0 011-1h14a1 1 0 011 1v.441zm0 1.118V17a1 1 0 01-1 1H5a1 1 0 01-1-1V8.559l7.33 3.665a1.5 1.5 0 001.34 0L20 8.559z"
            fill="currentColor"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        />
    </svg>
);

export default SvgIcnEmailBold;
